import React, {type PropsWithChildren} from 'react';
import type {SuggestionProps} from '@tiptap/suggestion';

import classNames from 'classnames';
import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';

import {sendToStatist} from '@time-webkit/statist';
import {type IEditor} from 'packages/editor';

import {MentionList} from '../../../../components/mention-list';

import type {EmojiMention} from '../../types';

import styles from './styles.module.css';

type MentionListProps = {
    getMentions: (query: string) => Promise<EmojiMention[]>;
    editor?: IEditor;
} & Pick<SuggestionProps<EmojiMention>, 'query' | 'command' | 'decorationNode'>;

const Handle: React.FC<PropsWithChildren> = (props) => {
    const typographyCls = useTypography({
        size: TypographySize.BodyL,
    });

    return <span className={classNames(styles.handle, typographyCls)}>{props.children}</span>;
};

const MentionOption = ({handle, url}: EmojiMention) => {
    return <Handle><span className={classNames('emoticon', styles.icon)} style={{backgroundImage: `url(${url})`}} />{':' + handle + ':'}</Handle>;
};

export const EmojiList: React.FC<MentionListProps> = (props) => {
    const {query, getMentions, command, decorationNode} = props;
    const onSelect = (_: EmojiMention, index: number) => {
        sendToStatist('editor.searchEmoji.resultTap', {
            resultNumber: index + 1,
        });
    };

    return (
        <MentionList
            query={query}
            command={command}
            decorationNode={decorationNode}
            getMentions={getMentions}
            renderMentionOption={(item: EmojiMention) => <MentionOption {...item} />}
            onSelect={onSelect}
            editor={props.editor}
            shouldRequestOnFocus={true}
        />
    );
};
